import { Directive, Input, Output, EventEmitter, ChangeDetectorRef, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Subscription } from "rxjs/Subscription";

/**
 * Generated class for the DebouncedInputDirective directive.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
 * for more info on Angular Directives.
 */
@Directive({
    selector: '[debounced][ngModel]' // Attribute selector
})
export class DebouncedDirective implements OnChanges {

    @Input('debounced') set setTime(time: number) {

        this.debouncedStop = !time;
        this.debouncedTime = time;

    }

  //@Input('debounced-stop') debouncedStop: boolean;
    @Input('ngModel') debouncedModel: any;

    // Ref.: https://stackoverflow.com/questions/34990102/angular2-data-binding-for-custom-reusable-component
    // note that this must be named as the input name + "Change"
    // See https://blog.thoughtram.io/angular/2016/10/13/two-way-data-binding-in-angular-2.html
    @Output() debouncedModelChange: any = new EventEmitter();

    debouncedTime: number;
    debouncedStop: boolean;

    modelChanged: Subject<any> = new Subject<any>();
    modelChangeSubscription: Subscription;
    onChangesCallback: Function;

    constructor(private ref: ChangeDetectorRef, private zone: NgZone) {

        this.debouncedStop = true;
        this.debouncedStart();

    }

    debouncedStart() {

        // Ref: https://www.lucidchart.com/techblog/2016/05/04/angular-2-best-practices-change-detector-performance/
        this.onChangesCallback = () => {
            this.zone.run(() => {
                this.ref.markForCheck();
            });
        };

        // Ref.: https://stackoverflow.com/questions/32051273/angular-and-debounce
        this.modelChangeSubscription = this.modelChanged
            .debounceTime((this.debouncedTime || 1500)) // wait 300ms after the last event before emitting last event
            .distinctUntilChanged() // only emit if value is different from previous value
            .subscribe(data => {
                this.debouncedModel = data;
                if (!this.debouncedStop) this.debouncedModelChange.emit(data);
            });

    }

    ngOnChanges(changes: SimpleChanges): void {

        if('debouncedModel' in changes) {
            this.updateData(changes.debouncedModel.currentValue);
            this.onChangesCallback();
        }

    }

    ngOnDestroy() {

        this.modelChangeSubscription.unsubscribe();

    }

    private updateData(data: any) {

        this.modelChanged.next(data);

    }

}



// WEBPACK FOOTER //
// ./src/directives/debounced.ts